export const ValidationRegular = {
  BIO: /^(?!.*\s{2,})[A-Za-zА-Яа-яЁё'`-]+(?: [A-Za-zА-Яа-яЁё'`-]+)*$/,
  MAIL: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/,
  INN: /^(?:\d{10}|\d{12})$/,
  QUANTITY: /^(?!0+$)\d+$/,
  REVENUE: /^(?:$|(?!0+(?:[.,]0+)?$)(?![.,])\d+(?:[.,]\d+)?)$/,
};

const isDev = __MODE__ == 'development';

// Функция для валидации ИНН по алгоритму контрольных сумм
export const validateINN = (inn: string, clientType?: string): boolean => {
  if (!inn) {
    return false;
  }

  if (isDev) return true;

  if (!ValidationRegular.INN.test(inn)) {
    return false;
  }

  // Не пропускаем ИНН, состоящий только из нулей
  if (/^0+$/.test(inn)) {
    return false;
  }

  // ИНН юридического лица (10 цифр)
  if (inn.length === 10) {
    // Веса для расчета контрольной суммы
    const weights = [2, 4, 10, 3, 5, 9, 4, 6, 8, 0];

    // Вычисляем контрольную сумму
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(inn[i]) * weights[i];
    }

    // Вычисляем контрольное число
    let checkDigit = sum % 11;

    // Если контрольное число больше 9, то берем остаток от деления на 10
    if (checkDigit > 9) {
      checkDigit = checkDigit % 10;
    }

    // Сравниваем с десятым знаком ИНН
    return checkDigit === parseInt(inn[9]);
  }

  // ИНН физического лица или ИП (12 цифр)
  if (inn.length === 12) {
    // Веса для расчета первой контрольной суммы (11-й знак)
    const weights1 = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0];
    // Веса для расчета второй контрольной суммы (12-й знак)
    const weights2 = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0];

    // Вычисляем первую контрольную сумму
    let sum1 = 0;
    for (let i = 0; i < 10; i++) {
      sum1 += parseInt(inn[i]) * weights1[i];
    }

    // Вычисляем первое контрольное число
    let checkDigit1 = sum1 % 11;

    // Если контрольное число больше 9, то берем остаток от деления на 10
    if (checkDigit1 > 9) {
      checkDigit1 = checkDigit1 % 10;
    }

    // Проверяем соответствие первой контрольной цифры
    if (checkDigit1 !== parseInt(inn[10])) {
      return false;
    }

    // Вычисляем вторую контрольную сумму
    let sum2 = 0;
    for (let i = 0; i < 11; i++) {
      sum2 += parseInt(inn[i]) * weights2[i];
    }

    // Вычисляем второе контрольное число
    let checkDigit2 = sum2 % 11;

    // Если контрольное число больше 9, то берем остаток от деления на 10
    if (checkDigit2 > 9) {
      checkDigit2 = checkDigit2 % 10;
    }

    // Сравниваем со второй контрольной цифрой
    return checkDigit2 === parseInt(inn[11]);
  }

  return false;
};
